module.exports = __webpack_public_path__ + "play-store-icon-0d69da10f071de57b32b.png";